import { usePreferences } from 'context/preferences/PreferencesContext'
import { ContactCompanyType } from 'models/contact_companies'
import { useParams } from 'react-router-dom'
import { getIdWithPrefix } from 'utils/pathUtils'
import { NewK12DistrictPage } from './new-company-pages/NewK12DistrictPage'

export default function K12DistrictPage() {
  const urlParams = useParams()
  const { preferences } = usePreferences()
  const k12ChainId = urlParams?.id
    ? getIdWithPrefix(
        urlParams?.id,
        preferences?.company_type_prefix_map[ContactCompanyType.K12District]
      )
    : undefined

  return <NewK12DistrictPage k12DistrictID={k12ChainId} />
}
